import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
import stl from "./SuggestionsContainer.module.css";
import useIsMobile from "@hooks/useIsMobile";
import useHelpers from "@hooks/useHelpers";
import { ModernCard } from "@/components/SearchComponent/ModernCard";
var SuggestionsContainerOnline = function SuggestionsContainerOnline(props) {
  var isMobile = useIsMobile();
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.SuggestionsContainerOnline
  }, /*#__PURE__*/React.createElement("div", {
    className: ["container", stl.revampedHome].join(" ")
  }, /*#__PURE__*/React.createElement("h2", {
    className: ["big", stl.revampedTitle].join(" ")
  }, props.title), /*#__PURE__*/React.createElement("div", {
    className: [stl.allCarsResult, stl.allCarsResultRevamped].join(" ")
  }, props.similarPosts.map(function (post, i) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModernCard, {
      post: post,
      key: "suggestionsContainerOnline_".concat(post.id),
      rank: i,
      page: 1,
      fromHomePage: true,
      sectionType: "home page"
    }));
  })), /*#__PURE__*/React.createElement("a", {
    href: createUrl("/filters", _defineProperty({}, "condition_id", props.isNew ? 1 : 0), {
      referral_location: "Home",
      browse_variant: "view_all",
      variant_value: "view all"
    }),
    state: {
      search_type: "homepage_listing"
    },
    className: [["redBtn", "moreSameCar", stl.moreSameCar, stl.showMorwBtn].join(" ")].join(" ")
  }, props.btnTxt))));
};
export default SuggestionsContainerOnline;